import { useQuery } from "@apollo/client";
import { SCAN } from "../scans.queries";
import {
  ScanQuery,
  ScanQueryVariables,
} from "../../../__generated__/ScanQuery";

export const useScan = (id: number) => {
  return useQuery<ScanQuery, ScanQueryVariables>(SCAN, { variables: { id } });
};
